import { Table } from "react-bootstrap";
import { useState, useEffect, useContext } from "react";
import axios from "axios";
import "../components/Reminder.css";
import { API_URL } from "../App";
import { UserDataContext } from "../components/UserDataContext";

export default function DataOwners() {
  const { userData } = useContext(UserDataContext);
  const [data, setData] = useState([]);

  useEffect(() => {
    if (userData) {
      axios
        .get(`${API_URL}/owners/${userData.cookie}`)
        .then((response) => {
          setData(response.data);
        })
        .catch((error) => {
          console.error(
            "Błąd podczas pobierania danych. Najprawdopodobniej utracono połączenie z internetem.",
            error
          );
        });
    }
  }, [userData]);

  if (userData && userData.admin === "1") {
    return (
      <div>
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>ID</th>

              <th>Email - Właściciel Grupy</th>
            </tr>
          </thead>

          <tbody>
            {data.map((item) => (
              <tr key={item.id}>
                <td className="td-centered">{item.id}</td>
                <td>{item.owner}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    );
  }
}
